<div class="flex mb-3">
  <p-iconField iconPosition="left">
    <p-inputIcon styleClass="fas fa-search" />
    <input
      class="w-20rem"
      pInputText
      #searchQuery
      (keyup)="updateList(searchQuery.value)"
      placeholder="durchsuchen ..." />
  </p-iconField>
</div>
<p-accordion *ngIf="itemsFiltered.length">
  @for (item of itemsFiltered; track item.key) {
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex gap-3">
          <i *ngIf="icon" [class]="icon"></i>
          {{ item.name }}
        </div>
      </ng-template>

      <div class="p-datatable">
        <table class="p-datatable-table w-full">
          <tbody class="p-datatable-tbody">
            <tr
              [class]="
                hasErrors($index, 'districtKey')
                  ? 'font-italic font-bold text-red-500'
                  : hasWarnings($index, 'districtKey')
                    ? 'font-italic font-bold text-yellow-500'
                    : ''
              ">
              <td><strong>Schlüssel</strong></td>
              <td>{{ item.key }}</td>
            </tr>
            <tr>
              <td><strong>Name</strong></td>
              <td>{{ item.name }}</td>
            </tr>
            <tr>
              <td><strong>Beschreibung</strong></td>
              <td
                [class]="
                  !item.description ? 'text-color-secondary font-italic' : ''
                "
                [innerHTML]="item.description || 'k. A.'"></td>
            </tr>
            <tr
              [class]="
                hasErrors($index, 'geoPositionX') ||
                hasErrors($index, 'geoPositionY')
                  ? 'font-italic font-bold text-red-500'
                  : hasWarnings($index, 'geoPositionX') ||
                      hasWarnings($index, 'geoPositionY')
                    ? 'font-italic font-bold text-yellow-500'
                    : ''
              ">
              <td><strong>Koordinaten</strong></td>
              <td>
                {{ item.geoPositionX || '-' }} | {{ item.geoPositionY || '-' }}
              </td>
            </tr>
            <tr>
              <td><strong>Adresse</strong></td>
              <td
                [class]="
                  !item.address ? 'text-color-secondary font-italic' : ''
                "
                [innerHTML]="item.address || 'k. A.'"></td>
            </tr>
            <tr>
              <td><strong>Informationen</strong></td>
              <td
                [class]="
                  !item.information ? 'text-color-secondary font-italic' : ''
                "
                [innerHTML]="item.information || 'k. A.'"></td>
            </tr>
            <tr>
              <td><strong>Kontakt</strong></td>
              <td
                [class]="
                  !item.contact ? 'text-color-secondary font-italic' : ''
                "
                [innerHTML]="item.contact || 'k. A.'"></td>
            </tr>
            <tr>
              <td><strong>Gruppe</strong></td>
              <td
                [class]="!item.group ? 'text-color-secondary font-italic' : ''"
                [innerHTML]="item.group || 'k. A.'"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </p-accordionTab>
  }
</p-accordion>
